<template>
  <div id="day-rain">
    <div class="dayRain-title">
      {{$t("cumulativeRainfall")}}
    </div>
    <div class="dayRain-content">
      <dv-border-box-13>
        <div class="dayRain-contentAll">
          <div class="content-title">
            <div class="contentTitle-img"><img :src="rainImg"></div>
            <div class="contentTitle-name">{{dayRainState}}</div>
          </div>
          <div class="content-rain">
            <div class="contentRain-name">{{$t("dailyRainfall")}}</div>
            <div :class="dayRainFlg == false ? 'contentRain-number' : 'contentRain-number1'">{{dayRainfall}}mm</div>
          </div>
          <dv-decoration-2 class="content-dv2" />
          <div class="content-input">
            <div class="contentInput-boundary">
              <div class="boundary-name">{{$t("boundary")}}</div>
              <div class="boundary-input">
                <el-input v-model="input" placeholder="0" type='number'></el-input>
              </div>
              <div class="boundary-btn">
                <el-button @click="setRainHour()">{{$t("submit")}}</el-button>
              </div>
            </div>
            <dv-decoration-4 class="content-input-dv4" />
            <div class="contentInput-warn">
              <div class="warn-name">{{$t("cordon")}}</div>
              <div class="warn-input">
                <el-input v-model="warnInput" placeholder="0" type='number'></el-input>
              </div>
              <div class="warn-btn">
                <el-button @click="setRainWarn">{{$t("submit")}}</el-button>
              </div>
            </div>
          </div>
        </div>
      </dv-border-box-13>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import {getTimeDeviceHistory, getAttributesClient, postClientInfo} from "../untils/api/home";
  export default {
    name: 'DayRain',
    data() {
      return {
        rainImg: '',
        input: '',
        realInput: '',
        warnInput: '',
        realWarnInput: '',
        dayRainfall: '-',
        dayRainState: '',
        dayRainFlg: false,
        deviceInfo: {},
        key: '',
        credentialsId: '',
        dayTime: null,
      }
    },
    beforeDestroy() {
      clearInterval(this.dayTime);
      this.dayTime = null;
    },
    methods: {
      /**
       * 日雨量初期化
       * @param deviceInfo
       * @param credentialsId
       * @param key
       */
      iniDayRain(deviceInfo, credentialsId, key) {
        this.deviceInfo = deviceInfo;
        this.credentialsId = credentialsId;
        this.key = key;
        this.rainImg = '';
        this.input = '';
        this.realInput = '';
        this.warnInput = '';
        this.realWarnInput = '';
        this.dayRainfall = '-';
        this.dayRainState = '';
        this.dayRainFlg = false;
        if(this.dayTime !== null){
          clearInterval(this.dayTime);
          this.dayTime = null;
        }
      },

      /**
       * 获取日分界值以及雨量警告值
       */
      getBoundary() {
        let boundaryNum = 0;//初期日分界值
        let warnNum = 0;//初期雨量警告值
        getAttributesClient(this.credentialsId).then(response => {
          for (let obj in response.client) {
            if(obj === 'rainHour'){
              boundaryNum = response.client[obj];//设置日分界值
            } else if(obj === 'rainWarn'){
              warnNum = response.client[obj];//设置雨量警告值
            }
          }
          //暂存日分界时
          this.input = boundaryNum;
          this.realInput = boundaryNum;
          //暂存日雨量警告线
          this.warnInput = warnNum;
          this.realWarnInput = warnNum;
          //每隔24小时获取一次日雨量
          this.dayHistory();
        }).catch(error => {
          console.log("error",error)
        })
      },

      /**
       * 每隔24小时获取一次日雨量
       */
      dayHistory() {
        if(this.dayTime != null){
          clearInterval(this.dayTime);
          this.dayTime = null;
        }
        this.dayRainHistory();//获取日雨量
        this.dayTime = window.setInterval(() => {
          setTimeout(() => {
            this.dayRainHistory();//获取日雨量
          }, 0)
        }, 1000 * 60 * 60 * 12);
      },

      /**
       * 获取日雨量
       */
      dayRainHistory() {
        let format = 'YYYY-MM-DD ' + this.input + ':00:00';
        //let startTime = new Date(moment().startOf('day').subtract(1,"days").format(format)).getTime();
        // let startTime = new Date(moment().startOf('day').format(format)).getTime();
        // let endTime = new Date(moment().startOf('day').subtract(-1,"days").format(format)).getTime();
        let endTime = new Date(moment().startOf('day').format(format)).getTime();
        let startTime = new Date(moment().startOf('day').subtract(1,"days").format(format)).getTime();
        getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, startTime, endTime, 0, 'NONE').then(response => {
          if(JSON.stringify(response) === "{}") {
            this.dayRainfall = "-";
            return;
          }
          let index = '';
          for(let obj in response) {
            for(let i = 0; i < response[obj].length - 1; i++){
              if(parseFloat(response[obj][i].value) < parseFloat(response[obj][i + 1].value)){
                index = i;
                break;
              }
            }
            //获取日雨量
            if(index === ''){
              this.dayRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
            } else {
              this.dayRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][index + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2);
            }
            //雨量状态
            if(parseFloat(this.dayRainfall) >= 50) {
              this.dayRainState = this.$t("rainstorm");
              this.rainImg = require('./img/rain8.png');
            } else if(parseFloat(this.dayRainfall) >= 25) {
              this.dayRainState = this.$t("heavyRain");
              this.rainImg = require('./img/rain7.png');
            }else if(parseFloat(this.dayRainfall) >= 10) {
              this.dayRainState =this.$t("moderateRain");
              this.rainImg = require('./img/rain6.png');
            }else if(parseFloat(this.dayRainfall) > 0) {
              this.dayRainState = this.$t("lightRain");
              this.rainImg = require('./img/rain5.png');
            } else {
              this.dayRainState = this.$t("noRain");
              this.rainImg = require('./img/rain9.png');
              //this.dayRainState = '小雨';
              //this.weatherImg = require('./img/rain1.png');
            }
            this.warnDisplay();//设置警戒状态
          }
        }).catch(error => {
          console.log("error",error);
        })
      },

      /**
       * 设置警戒状态
       */
      warnDisplay() {
        if((parseFloat(this.dayRainfall) > parseFloat(this.warnInput)) && (parseFloat(this.warnInput) > 0)) {
          this.dayRainFlg = true;
        } else {
          this.dayRainFlg = false;
        }
      },

      /**
       * 上传日分界线
       */
      setRainHour() {
        let hour = this.input === '' ? 0 : parseFloat(this.input);
        if(hour > 23 || hour < 0){
          this.$message({
            showClose: true,
            type: "warning",
            message: this.$t("boundaryWarn")
          });
          this.input = this.realInput;
        }  else {
          let param = {rainHour: hour};
          postClientInfo(this.credentialsId, param).then(response => {
            this.realInput = this.input;
            this.$message({
              showClose: true,
              type: "info",
              message: this.$t("boundarySuccess")
            });
          }).catch(error => {
            this.input = this.realInput;
            this.$message({
              showClose: true,
              type: "warning",
              message: this.$t("boundaryError")
            });
            console.log("error",error)
          })
          this.dayHistory();
        }
      },

      /**
       * 上传雨量警戒值
       */
      setRainWarn() {
        let warn = this.warnInput === '' ? 0 : parseFloat(this.warnInput);
        if(warn < 0){
          this.$message({
            showClose: true,
            type: "warning",
            message: this.$t("cordonWarn")
          });
          this.warnInput = this.realWarnInput;
        } else {
          let param = {rainWarn: warn};
          postClientInfo(this.credentialsId, param).then(response => {
            this.realWarnInput = this.warnInput;
            this.$message({
              showClose: true,
              type: "info",
              message: this.$t("cordonSuccess")
            });
          }).catch(error => {
            this.warnInput = this.realWarnInput;
            this.$message({
              showClose: true,
              type: "warning",
              message: this.$t("cordonError")
            });
            console.log("error",error)
          })
          this.warnDisplay();
        }
      }
    }
  }
</script>

<style lang="less">
  @import "less/DayRain";
</style>



// WEBPACK FOOTER //
// src/components/DayRain.vue